import {
  InboxOutlined,
  StarOutlined,
  TeamOutlined,
  UserOutlined,
  RobotOutlined,
  SettingOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import type { ReactNode } from "react";

export type NavItem = {
  key: string;
  to: string;
  label: string;
  icon: ReactNode;
};

export const NAV_ITEMS: NavItem[] = [
  { key: "inbox", to: "/", label: "收件箱", icon: <InboxOutlined /> },
  { key: "starred", to: "/?tier=important", label: "重要", icon: <StarOutlined /> },
  { key: "cases", to: "/cases", label: "案件", icon: <FolderOpenOutlined /> },
  { key: "groups", to: "/groups", label: "群组", icon: <TeamOutlined /> },
  { key: "contacts", to: "/contacts", label: "联系人", icon: <UserOutlined /> },
  { key: "ai", to: "/ai", label: "AI 草稿", icon: <RobotOutlined /> },
];

export const SETTINGS_ITEM: NavItem = {
  key: "settings",
  to: "/settings",
  label: "设置",
  icon: <SettingOutlined />,
};

const byKey = (key: string): NavItem => NAV_ITEMS.find((it) => it.key === key)!;

export const MOBILE_NAV: NavItem[] = [
  byKey("inbox"),
  byKey("cases"),
  byKey("groups"),
  byKey("ai"),
  SETTINGS_ITEM,
];
